
const rooturl = 'http://fish.api.tcctop.com:9301'
export default {
    customer:`${rooturl}/managerServer/common/customer`,
    google:`${rooturl}/managerServer/common/down/android`,
    offical:`${rooturl}/managerServer/common/down/website`,
    ios:`${rooturl}/managerServer/common/down/ios`,
}